import * as Contentful from 'contentful'
import * as CFRichTextTypes from '@contentful/rich-text-types'
import { TypeComponentLink } from './component-link'

export enum ComponentCtaButtonType {
  Link = 'Link',
  DefaultProductInstall = 'Custom: Default Product Install',
  LlamaOrKeyboardInstall = 'Custom: Llama or Keyboard Install',
  LlamaInstall = 'Custom: Llama Install',
  LlamaMacInstall = 'Custom: Llama Mac Install',
  LlamaWindowsInstall = 'Custom: Llama Windows Install',
  ExtensionInstall = 'Custom: Extension Install',
  ExtensionOrKeyboardInstall = 'Custom: Extension or Keyboard Install',
  ExtensionChromeInstall = 'Custom: Extension Chrome Install',
  ExtensionFirefoxInstall = 'Custom: Extension Firefox Install',
  ExtensionSafariInstall = 'Custom: Extension Safari Install',
  ExtensionEdgeInstall = 'Custom: Extension Edge Install',
  IOSInstall = 'Custom: iOS Install',
  AndroidInstall = 'Custom: Android Install',
  SignUpProductRecommendation = 'Custom: Signup Product Recommendation',
  SignUpGoogle = 'Custom: Signup with Google',
  GOInstall = 'Custom: GrammarlyGO Install',
}

export enum ComponentCtaButtonColor {
  // WDK 2024 Brand Refresh
  WDK24PrimaryLightBg = '24 Primary (Light Bg) - Green',
  WDK24SecondaryLightBg = '24 Secondary (Light Bg) - Transparent with Border',
  WDK24TertiaryLightBg = '24 Tertiary (Light Bg) - Transparent',
  WDK24PrimaryDarkBg = '24 Primary (Dark Bg) - White',
  WDK24SecondaryDarkBg = '24 Secondary (Dark Bg) - Transparent with Border',
  WDK24TertiaryDarkBg = '24 Tertiary (Dark Bg) - Transparent',
  WDK24LimeGreenDarkBg = '24 Secondary (Dark Bg) - Lime Green Transparent with Border',
  WDK24LimeGreenBlackTextDarkBg = '24 Primary (Dark Bg) - Black Text, Lime Green',
  WDK24GoogleSecondaryDarkBg = '24 Secondary (Dark Bg) - White Text, Google Sign Up',
  WDK24BlackWhiteText = '24 Primary (Light Bg) - White text, Black',
  WDK24WhiteBlackText = '24 Secondary (Dark Bg) - Black text, White',

  // WhiteTextGreenButton will be renamed to "Primary (Light Bg) - White Text, Green Button"
  WhiteTextGreenButton = 'White Text, Green Button',
  PrimaryDarkBg = 'Primary (Dark Bg) - Blue Text, White Button',
  Secondary = 'Secondary (Light Bg) - Green Text, White Button with Border',
  SecondaryDarkBg = 'Secondary (Dark Bg) - White Text, Transparent Button with Border',
  Tertiary = 'Tertiary (Light Bg) - Grey Text, Transparent Button',
  GoPrimaryDarkBg = 'GO Primary (Dark Bg) - Dark Green Text, White Button',
  GoSecondaryDarkBg = 'GO Secondary (Dark Bg) - White Text, Transparent Button with Border',

  // The following buttons will be deprecated in
  WhiteTextBlueButton = 'White Text, Blue Button',
  BlueTextGreyButton = 'Blue Text, Grey Button',
  GreenTextGreyButton = 'Green Text, Grey Button',
}

export enum CtaDescriptionPosition {
  Left = 'Left',
  Center = 'Center',
}

export enum CtaDescriptionWidth {
  Fixed = 'Fixed',
  Auto = 'Auto',
}

export enum ComponentCtaButtonSize {
  Large = 'Large',
}

export interface TypeComponentCtaButtonFields {
  internalName: Contentful.EntryFields.Symbol
  type: ComponentCtaButtonType
  color: ComponentCtaButtonColor
  size?: ComponentCtaButtonSize
  ctaText: CFRichTextTypes.Document
  showArrow?: Contentful.EntryFields.Boolean
  targetLink?: TypeComponentLink
  ctaUnderLink?: TypeComponentLink
  ctaUnderDescription?: CFRichTextTypes.Document
}

export type TypeComponentCtaButton = Contentful.Entry<TypeComponentCtaButtonFields>
